export const PRODUCT_SELECTION_COLUMNS = [
  {
    name_of_db_column: 'productName',
    label_of_column: 'Product Name',
    filterable: true,
    sortable: true,
  },
  {
    name_of_db_column: 'productId',
    label_of_column: 'Product Id',
    filterable: true,
    sortable: true,
  },
]

export const PRODUCT_SELECTION_COLUMNS_WITH_GTIN = [
 ...PRODUCT_SELECTION_COLUMNS,
  {
    name_of_db_column: 'gtin',
    label_of_column: 'GTIN',
    filterable: true,
    sortable: true,
  },
]

export const BONUS_PRODUCTS_DROPDOWN_OPTIONS = [
  {
    displayText: 'Product ID',
    id: 'productId',
    isBadge: false,
  },
]

export const BONUS_PRODUCTS_DROPDOWN_OPTIONS_WITH_GTIN = [
  {
    displayText: 'Product ID / GTIN',
    id: 'productId/gtin',
    isBadge: false,
  },
]